"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.icons = exports.Icon = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const classnames_1 = __importDefault(require("classnames"));
const prop_types_1 = __importDefault(require("prop-types"));
const react_jss_1 = __importDefault(require("react-jss"));
const svgs_1 = __importDefault(require("./svgs"));
const icons_style_1 = __importDefault(require("./icons.style"));
const IconComp = ({ classes, name, className }) => {
    const IconSvgComponent = svgs_1.default[name];
    if (!IconSvgComponent) {
        console.warn(`Icon ${name} does not exist`);
        return null;
    }
    /**
     * The svg icons is actually passed in the CSS.
     * Indeed, the original idea was to use svgr loader and
     * import the icons as react components, but that led to
     * many build issues... Using the svg's url in an <img />
     * would work too, but we couldn't customize the color that way.
     */
    return jsx_runtime_1.jsx("div", { className: classnames_1.default(className, classes.icon) }, void 0);
};
IconComp.propTypes = {
    // prop size is used in styles
    // eslint-disable-next-line
    size: prop_types_1.default.oneOfType([prop_types_1.default.number, prop_types_1.default.string]),
    // prop color is used in styles
    // eslint-disable-next-line
    color: prop_types_1.default.string,
    classes: prop_types_1.default.object.isRequired,
    name: prop_types_1.default.string.isRequired,
    className: prop_types_1.default.object
};
IconComp.defaultProps = {
    size: null,
    color: null,
    className: null
};
const Icon = react_jss_1.default(icons_style_1.default)(IconComp);
exports.Icon = Icon;
const icons = {};
exports.icons = icons;
Object.keys(svgs_1.default).forEach(key => {
    icons[key] = props => jsx_runtime_1.jsx(Icon, Object.assign({ name: key }, props), void 0);
});
//# sourceMappingURL=index.js.map